"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KanbanView = void 0;
const config_1 = require("../../config");
const engine_1 = require("../../engine");
const i18n_1 = require("../../exports/i18n");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const selectors_1 = require("../../exports/store/selectors");
const types_1 = require("../../types");
const card_view_1 = require("./card_view");
const utils_1 = require("../../utils");
class KanbanView extends card_view_1.CardView {
    static findGroupFieldId(srcView, fieldMap) {
        const column = srcView.columns.find(item => {
            const field = fieldMap[item.fieldId];
            return field.type === types_1.FieldType.SingleSelect ||
                (field.type === types_1.FieldType.Member && !field.property.isMulti);
        });
        return column === null || column === void 0 ? void 0 : column.fieldId;
    }
    static getFieldProperty(column, fieldMap) {
        if (!column) {
            return [];
        }
        const field = fieldMap[column.fieldId];
        if (field.type === types_1.FieldType.Member) {
            return field.property.unitIds;
        }
        if (field.type === types_1.FieldType.SingleSelect) {
            return field.property.options.map(item => item.id);
        }
        return [];
    }
    static getHiddenGroupMap(field) {
        if (!field) {
            return;
        }
        const hiddenGroupMap = {};
        if (field.type === types_1.FieldType.SingleSelect) {
            field.property.options.forEach(item => {
                hiddenGroupMap[item.id] = false;
            });
        }
        else {
            field.property.unitIds.forEach(id => {
                hiddenGroupMap[id] = false;
            });
        }
        return hiddenGroupMap;
    }
    static defaultStyle(snapshot, activeViewId) {
        const srcView = this.getSrcView(snapshot, activeViewId);
        // the first attachment field will be default cover field
        const kanbanFieldId = this.findGroupFieldId(srcView, snapshot.meta.fieldMap);
        const field = snapshot.meta.fieldMap[kanbanFieldId];
        return {
            isCoverFit: false,
            coverFieldId: undefined,
            kanbanFieldId,
            isColNameVisible: true,
            hiddenGroupMap: KanbanView.getHiddenGroupMap(field),
        };
    }
    static generateDefaultProperty(snapshot, activeViewId) {
        const srcView = this.getSrcView(snapshot, activeViewId);
        const views = snapshot.meta.views;
        return {
            id: model_1.DatasheetActions.getNewViewId(views),
            name: model_1.DatasheetActions.getDefaultViewName(views, store_1.ViewType.Kanban),
            type: store_1.ViewType.Kanban,
            columns: this.defaultColumns(srcView, 2),
            rows: this.defaultRows(srcView),
            style: this.defaultStyle(snapshot, activeViewId),
            groupInfo: [{ fieldId: this.findGroupFieldId(srcView, snapshot.meta.fieldMap), desc: false }],
            displayHiddenColumnWithinMirror: true
        };
    }
    static getViewIntroduce() {
        return {
            title: (0, i18n_1.t)(i18n_1.Strings.kanban_view),
            desc: (0, i18n_1.t)(i18n_1.Strings.kanban_guide_desc),
            videoGuide: (0, utils_1.integrateCdnHost)(config_1.Settings.view_kanban_guide_video.value),
        };
    }
}
exports.KanbanView = KanbanView;
KanbanView.setViewStyle2Action = (snapshot, payload) => {
    const { viewId, styleKey, styleValue } = payload;
    const viewIndex = (0, selectors_1.getViewIndex)(snapshot, viewId);
    if (viewIndex < 0) {
        return null;
    }
    const view = snapshot.meta.views[viewIndex];
    if (view.type !== store_1.ViewType.Kanban || styleValue === view.style[styleKey]) {
        return null;
    }
    if (styleValue == null) {
        return {
            n: engine_1.OTActionName.ObjectDelete,
            p: ['meta', 'views', viewIndex, 'style', styleKey],
            od: view.style[styleKey],
        };
    }
    return {
        n: engine_1.OTActionName.ObjectReplace,
        p: ['meta', 'views', viewIndex, 'style', styleKey],
        oi: styleValue,
        od: view.style[styleKey],
    };
};
//# sourceMappingURL=kanban_view.js.map